var _path, _line, _path2, _line2, _line3, _line4, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrokenPipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14V13H17V14C17 15.6569 18.3431 17 20 17C21.6569 17 23 15.6569 23 14V6C23 4.34315 21.6569 3 20 3C18.3431 3 17 4.34315 17 6V7H19V6C19 5.44772 19.4477 5 20 5C20.5523 5 21 5.44772 21 6Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.2,
    y1: 13.4,
    x2: 13.4,
    y2: 15.8,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7V6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V13H7V14C7 15.6569 5.65685 17 4 17C2.34315 17 1 15.6569 1 14V6C1 4.34315 2.34315 3 4 3C5.65685 3 7 4.34315 7 6V7H5Z",
    fill: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 18,
    y2: 7,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 13,
    x2: 9,
    y2: 13,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 13,
    x2: 18,
    y2: 13,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L12.4565 18.4275C13.1358 19.5597 12.3203 21 11 21C9.67971 21 8.8642 19.5597 9.54349 18.4275L11 16Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenPipe);
export default __webpack_public_path__ + "static/media/BrokenPipe.070a4a13c09434928d4b3b986b19cbb5.svg";
export { ForwardRef as ReactComponent };